import { classNames } from 'libs/react';
import { useRef } from 'libs/react';
import { React } from 'libs/react';
import './Content.scss';
/**
 * @component Content
 * @since 1.0.0
 */
export function Content(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const node = useRef(null);
    /**
     * @function onScroll
     * @since 1.0.0
     * @hidden
     */
    function onScroll() {
        window.dispatchEvent(new Event('scroll'));
    }
    const className = classNames('content', 'content--' + style, props.className);
    return (React.createElement("article", { ref: node, className: className, onScroll: onScroll }, props.children));
}
